import classNames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

class SchedulePeriod extends React.Component {
  static propTypes = {
    beginTime: PropTypes.number,
    disabled:  PropTypes.bool,
    endTime:   PropTypes.number.isRequired,
    startTime: PropTypes.number.isRequired
  }

  render() {
    const { beginTime, endTime, startTime, ...rest } = this.props;

    return (
      <select className={ classNames('form__field form__select', this.props.className) }
        { ...rest }>
        <option />
        { this._renderOptions() }
      </select>
    );
  }

  // private

  _renderOptions() {
    const options = [];

    const { beginTime, startTime, endTime } = this.props;

    for (let i = startTime; i <= endTime; i += 900) {
      const disabled = beginTime > i;
      const time     = moment.duration(i, 'seconds');

      options.push(
        <option disabled={ disabled } key={ i } value={ i }>
          { moment.utc(time.asMilliseconds()).format('h:mm a') }
        </option>
      );
    }

    return options;
  }
}

export default SchedulePeriod;



// WEBPACK FOOTER //
// ./app/components/managers/_SchedulePeriod.jsx